import { useState } from "react"
import { useVenereExperts } from "../../experts/hooks"
import VenereAvatar from "../../shared/core/VenereAvatar"
import VenerePlatformLayout from "../../shared/pages/VenerePlatformLayout"
import VenereConsultBox from "../components/VenereConsultBox"
import { VenereConsultsSummary } from "../components/VenereConsultsSummary"

const VenereConsults = () => {
  const { nutritionist, physician } = useVenereExperts()
  const [expandedCardId, setExpandedCardId] = useState<string | null>(null)

  const handleCardExpand = (cardId: string) => {
    setExpandedCardId(expandedCardId === cardId ? null : cardId)
  }

  return (
    <VenerePlatformLayout>
      <div className="p-4 space-y-6 md:p-8">
        <div className='flex flex-col items-center gap-4'>
          <div className='venere-text-heading text-center'>
            Devi prenotare un consulto?
          </div>
          <div className='venere-text-subheading text-center'>
            Seleziona il professionista di cui hai bisogno.
          </div>
          <VenereAvatar
            variant="welcome"
            size="xl"
          />
        </div>

        {/* Consults Summary */}
        <VenereConsultsSummary />

        {/* Expert Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {physician && (
          <VenereConsultBox
            id="physician"
            imageSrc={physician.calendly_data.calendly_user.avatar_url}
            imageAlt={`Avatar of ${physician.data.name} ${physician.data.family_name}`}
            role="Endocrinologo"
            name={`${physician.data.name} ${physician.data.family_name}`}
            expert={physician}
            imageClassName="rounded-[20px]"
            isExpanded={expandedCardId === "physician"}
            onExpand={handleCardExpand}
          />
        )}
        
        {nutritionist && (
          <VenereConsultBox
            id="nutritionist"
            imageSrc={nutritionist.calendly_data.calendly_user.avatar_url}
            imageAlt={`Avatar of ${nutritionist.data.name} ${nutritionist.data.family_name}`}
            role="Nutrizionista"
            name={`${nutritionist.data.name} ${nutritionist.data.family_name}`}
            expert={nutritionist}
            imageClassName="rounded-[20px]"
            isExpanded={expandedCardId === "nutritionist"}
            onExpand={handleCardExpand}
          />
        )}
        
        <VenereConsultBox
          id="psychologist"
          imageSrc="/images/assets/LucioPoletti.png"
          imageAlt="Expert consultation"
          role="Psicologo"
          name="Lucio Poletti"
          imageClassName="rounded-[20px] w-[200px]"
          isExpanded={expandedCardId === "psychologist"}
          onExpand={handleCardExpand}
        />
        </div>
      </div>
    </VenerePlatformLayout>
  )
}

export default VenereConsults
